import { Routes, Route } from 'react-router-dom';
import './App.css';
import './common.css';
import Home from './pages/Home/Home';
import NotFound from './pages/NotFound/NotFound';
import SignUp from './components/SignUp/SignUp';
import SignUpSuccess from './pages/SignUpSuccess/SignUpSuccess';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signup-success" element={<SignUpSuccess />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
